import { Injector } from '@angular/core';
import { ButtonActionType, UiZoneWidgetAttributeConfig } from '@finxone-platform/shared/sys-config-types';
import { CtaButtonSignalService } from '../../../services/cta-button-signal-service/cta-button-signal.service';
import { markBeneficiaryAsFavoriteOrUnfavorite } from '../beneficiary-feature/mark-beneficiary-favorite-unfavorite';
import { editBeneficiary, editBeneficiaryUnified } from '../beneficiary-zone/edit-beneficiary.utils';
import { setBeneficiaryDataAndRedirectToEditBeneficiaryPage } from '../beneficiary-zone/redirect-to-edit-beneficiary.utils';
import { callRemoveBeneficiaryAPI } from '../beneficiary-zone/remove-beneficiary.utils';
import { callEditIntlBeneficiaryAPI } from '../beneficiary-zone/submit-edit-beneficiary-request.utils';
import { functionCtaType } from '../cta-button-actions.utils';
import { addEditBeneficiary } from '../domestic-payments/add-beneficiary';
import { updateBeneficiaryDetail } from '../domestic-payments/edit-beneficiary';
import { skipAddressRedirection } from '../domestic-payments/payment-flow-redirection';
import { updateBeneficiaryFormData } from '../domestic-payments/update-beneficiary-form-data';

export const beneficariesActions: Map<ButtonActionType, functionCtaType> = new Map([
  [
    ButtonActionType.REDIRECT_TO_EDIT_BENEFICIARY,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      setBeneficiaryDataAndRedirectToEditBeneficiaryPage(attri.widgetProperties, injector);
    },
  ],
  [
    ButtonActionType.ADD_BENEFICIARY,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      addEditBeneficiary(injector, attri.widgetProperties);
    },
  ],
  [
    ButtonActionType.UPDATE_BENEFICIARY_DETAILS,
    (injector: Injector) => {
      updateBeneficiaryDetail(injector);
    },
  ],
  [
    ButtonActionType.REMOVE_BENEFICIARY,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      callRemoveBeneficiaryAPI(attri.widgetProperties, injector);
    },
  ],
  [
    ButtonActionType.EDIT_BENEFICIARY,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      editBeneficiary(attri.widgetProperties, injector);
    },
  ],
  [
    ButtonActionType.EDIT_BENEFICIARY_UNIFIED,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      editBeneficiaryUnified(attri.widgetProperties, injector);
    },
  ],
  [
    ButtonActionType.SKIP_BENEFICIARY_ADDRESS,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      skipAddressRedirection(attri.widgetProperties, injector);
    },
  ],
  [
    ButtonActionType.MARK_FAVORITE_BENEFICIARY,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      markBeneficiaryAsFavoriteOrUnfavorite(attri.widgetProperties, injector, true);
    },
  ],
  [
    ButtonActionType.REMOVE_FAVORITE_BENEFICIARY,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      markBeneficiaryAsFavoriteOrUnfavorite(attri.widgetProperties, injector, false);
    },
  ],
  [
    ButtonActionType.USE_SUGGESTED_NAME_COP,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      updateBeneficiaryFormData(injector, attri.widgetProperties);
    },
  ],
]);
